import LanguageLocales from '@helsenorge/core-utils/constants/languages';
import enGB from '../resources/HN.CoreFrontend.NPM.Packages.CMS.Video.en-GB.json';
import nbNO from '../resources/HN.CoreFrontend.NPM.Packages.CMS.Video.nb-NO.json';
import nnNO from '../resources/HN.CoreFrontend.NPM.Packages.CMS.Video.nn-NO.json';
import seNO from '../resources/HN.CoreFrontend.NPM.Packages.CMS.Video.se-NO.json';
export const getResources = (language) => {
    switch (language) {
        case LanguageLocales.SAMI_NORTHERN:
            return seNO;
        case LanguageLocales.ENGLISH:
            return enGB;
        case LanguageLocales.NORWEGIAN_NYNORSK:
            return nnNO;
        case LanguageLocales.NORWEGIAN:
        default:
            return nbNO;
    }
};
